<div class="grid">
  <div class="col-12 mb-2">
    <div class="card title-card flex">
      <i class="pi pi-cloud-upload title-card-icon"></i>
      <div>
        <p class="mb-0 text-3xl title">{{'model.notifications' | transloco}}</p>
        <p>{{'menu.descriptions.notifications' | transloco}}</p>
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="card">
      <div class="p-datatable p-component p-datatable-hoverable-rows">
        <div class="p-datatable-header">
          <div class="flex flex-column sm:flex-row justify-content-between">
            <div class="flex flex-column md:flex-row">
              <button
                *ngIf="'ROLE_ADMIN' | userHasRole"
                [label]="'common.new' | transloco"
                pButton
                pRipple
                class="md:mr-2 p-button-primary mb-2 md:mb-0"
                routerLink="new"
                icon="pi pi-plus"
              ></button>
<!--              <button-->
<!--                *ngIf="'ROLE_ADMIN' | userHasRole"-->
<!--                [label]="'common.delete' | transloco"-->
<!--                [disabled]="selected.length == 0"-->
<!--                (click)="confirmAndDeleteSelected()"-->
<!--                pButton-->
<!--                pRipple-->
<!--                class="p-button-danger mb-2 sm:mb-0"-->
<!--                icon="pi pi-trash"-->
<!--              ></button>-->
            </div>
            <div *ngIf="!filtersFilled" class="flex flex-column md:flex-row justify-content-end">
              <button
                [label]="'common.filters' | transloco"
                (click)="filtersVisible = !filtersVisible"
                pButton
                class="p-button-secondary"
                icon="pi pi-sliders-h"
              ></button>
            </div>
            <div *ngIf="filtersFilled" class="flex flex-column md:flex-row justify-content-end">
              <button
                [label]="'common.filters' | transloco"
                (click)="filtersVisible = !filtersVisible"
                pButton
                class="p-button-secondary filtersFilled"
                icon="pi pi-filter"
              ></button>
            </div>
          </div>
        </div>
        <p-table
          [(first)]="first"
          [(rows)]="rows"
          [(selection)]="selected"
          [value]="notifications"
          [totalRecords]="totalNotifications"
          [responsive]="true"
          [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
          [paginator]="true"
          [rowsPerPageOptions]="[10,25,50]"
          [lazy]="true"
          (onLazyLoad)="onPageChange($event)"
          styleClass="p-datatable-striped"
          sortField="name"
          dataKey="dataKey"
        >
          <ng-template pTemplate="header">
            <tr>
              <th class="selection-column-width"></th>
              <th pSortableColumn="name">
                {{'attribute.name' | transloco}}<p-sortIcon field="name"></p-sortIcon></th>
              <th *ngIf="'ROLE_SUPER_ADMIN' | userHasRole">
                {{'attribute.tenant' | transloco}}</th>
              <th *ngIf="'ROLE_ADMIN' | userHasRole">
                {{'attribute.organization' | transloco}}</th>
              <th>
                {{'attribute.notificationType' | transloco}}</th>
              <th class="w-10rem">
                {{'common.actions' | transloco}}
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-notification let-expanded="expanded">
            <tr *ngIf="!loadingNotifications" class="fadein">
              <td>
                <span class="p-column-title bold">{{'common.expand' | transloco}}</span>
                <button
                  [pRowToggler]="notification"
                  [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                  pButton
                  pRipple
                  class="p-button-text p-button-rounded p-button-plain"
                  type="button"
                ></button>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.name' | transloco}}</span>
                <p class="text-right md:text-left">{{notification.name}}</p>
              </td>
              <td *ngIf="'ROLE_SUPER_ADMIN' | userHasRole">
                <span class="p-column-title bold">{{'attribute.tenant' | transloco}}</span>
                <a *ngIf="notification.tenantUuid" [routerLink]="['/management/tenants', notification.tenantUuid, 'details']">
                  {{notification.tenantUuid | tenantsResolver}}
                </a>
              </td>
              <td *ngIf="'ROLE_ADMIN' | userHasRole">
                <span class="p-column-title bold">{{'attribute.organization' | transloco}}</span>
                <a *ngIf="notification.organizationUuid" [routerLink]="['/management/organizations', notification.organizationUuid, 'details']">
                  {{notification.organizationUuid | organizationsResolver}}
                </a>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.notificationType' | transloco}}</span>
                <p-tag
                  [value]="(notification.frequency === 0 ? 'forms.notificationType.ALL' :
                   notification.frequency === 3600 ? 'forms.notificationType.HOURLY' : 'forms.notificationType.DAILY') | transloco"
                 >
                </p-tag>
              </td>
              <td>
                <span class="p-column-title bold">{{'common.actions' | transloco}}</span>
                <div class="flex justify-content-end">
                  <button
                    [routerLink]="notification.tenantUuid + '/' + notification.uuid + '/edit'"
                    pButton
                    pRipple
                    class="p-button-rounded btn-primary-light mr-2"
                    icon="pi pi-pencil"
                  ></button>
                  <button
                    *ngIf="'ROLE_ADMIN' | userHasRole"
                    (click)="confirmAndDelete(notification)"
                    pButton
                    pRipple
                    class="p-button-rounded btn-danger-light"
                    icon="pi pi-trash"
                  ></button>
                </div>
              </td>
            </tr>
            <tr *ngIf="loadingNotifications" class="fadein animation-delay-200 animation-fill-forwards no-opacity">
              <td class="row-height selection-column-width" *ngIf="'ROLE_SUPER_ADMIN' | userHasRole"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            </tr>
          </ng-template>
          <ng-template pTemplate="rowexpansion" let-notification>
            <tr>
              <td colspan="8">
                <div class="grid">
                  <div class="col-6">
                    <b>{{'attribute.topic' | transloco}}:</b>
                  </div>
                  <div class="col-6">
                    <b>{{'attribute.emails' | transloco}}:</b>
                  </div>
                  <div class="col-6">
                    <div *ngIf="notification.topic">{{notification.topic}}</div>
                    <div *ngIf="!notification.topic"><i>{{'empty.topic' | transloco}}</i></div>
                  </div>
                  <div class="col-6">
                    <ngx-json-viewer *ngIf="notification.emails" [json]="notification.emails"></ngx-json-viewer>
                    <div *ngIf="!notification.emails"><i>{{'empty.emails' | transloco}}</i></div>
                  </div>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="summary">
            <div class="flex align-items-center justify-content-between" *ngIf="totalNotifications == 0">
              {{'pagination.empty' | transloco}}
            </div>
            <div class="flex align-items-center justify-content-between" *ngIf="totalNotifications > 0">
              {{'pagination.showing' | transloco}} {{first+1}}
              {{'pagination.to' | transloco}} {{(first+rows) >= totalNotifications ? totalNotifications : (first+rows)}}
              {{'pagination.of' | transloco}} {{totalNotifications}}
              {{(totalNotifications > 1 ? 'pagination.entries':'pagination.entry') | transloco}}
            </div>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>

<p-sidebar [(visible)]="filtersVisible" position="right" [baseZIndex]="10000" [style]="{'width':'25em'}">
  <h2 style="margin-left: 10px">{{'common.filters' | transloco}}</h2>
  <div>

    <div class="col-12">
      <div class="col-12 form-field">
        <label for="name">{{'attribute.name' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <input
          [(ngModel)]="currentFilters.name"
          [focus]="filtersVisible"
          (keyup.enter)="filtersVisible = false; applyFilters()"
          pInputText
          appAutoFocus
          class="w-full"
          id="name"
          type="text"
        >
      </div>
    </div>

    <div class="col-12">
      <div class="col-12 form-field">
        <label for="notificationType">{{'attribute.notificationType' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-dropdown
          [(ngModel)]="currentFilters.frequency"
          [placeholder]="'select.notificationType' | transloco"
          [options]="notificationTypes | translateLabels:'name' | async"
          [showClear]="true"
          [autoDisplayFirst]="false"
          styleClass="w-full"
          id="notificationType"
          appendTo="body"
          optionLabel="name"
          optionValue="delay"
        ></p-dropdown>
      </div>
    </div>

    <div class="col-12" *ngIf="authGuardService.superAdminRequired()">
      <div class="col-12 form-field">
        <label for="tenant">{{'model.tenant' | transloco}}</label>
      </div>
      <div class="col-12">
        <p-multiSelect
          [(ngModel)]="currentFilters.tenantUuids"
          [placeholder]="'select.generic' | transloco"
          [options]="tenants"
          [filter]="true"
          styleClass="w-full"
          id="tenant"
          optionLabel="name"
          optionValue="uuid"
          filterBy="name"
          display="chip"
          appendTo="body"
        ></p-multiSelect>
      </div>
    </div>

    <div class="col-12">
      <p-button
        [label]="'common.filter' | transloco"
        [disabled]="!(
          currentFilters.name ||
          currentFilters.description ||
          currentFilters.frequency != null ||
          currentFilters.tenantUuids
        )"
        (onClick)="filtersVisible = false; applyFilters()"
        styleClass="p-button-primary mx-2 mt-2"
        type="button"
      ></p-button>
      <p-button
        [label]="'common.clear' | transloco"
        (click)="resetFilters(); filtersVisible = false;"
        styleClass="p-button-danger"
        type="button"
      ></p-button>
    </div>

  </div>
</p-sidebar>
